<template>
  <div class="flex flex-col gap-0.5">
    <div
      class="bg-surface-container-low rounded-t-medium rounded-b-extra-small relative flex flex-row p-3"
    >
      <h4 class="text-body-large text-on-surface-variant">
        {{ question.content }}
      </h4>
    </div>
    <template
      v-for="perspective in textFeedbacks.perspectives"
      :key="analysisPerspectiveKey(perspective)"
    >
      <SelectableTextFeedback
        v-for="feedback in feedbacksWithMember(perspective)"
        :key="feedback.id"
        :member="feedback.member"
        :date="feedback.date"
        :text="feedback.text"
        :is-selected="isFeedbackSelected(feedback.id)"
        @click="toggleFeedback(feedback.id)"
      />
    </template>
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import type { TextAnalysis, TextPerspectiveAnalysis } from '@/core/models/surveys-analytics'
  import { useUserStore } from '@/stores/user.store'
  import SelectableTextFeedback from './SelectableTextFeedback.vue'
  import { SELF_PERSPECTIVE_KEY } from '@/core/models/perspective'
  import { analysisPerspectiveKey } from '@/core/models/perspective-analysis'

  interface Props {
    textFeedbacks: TextAnalysis
    selectedFeedbackIds: Set<string>
  }

  const props = defineProps<Props>()
  const { user } = useUserStore()

  const question = computed(() => {
    return props.textFeedbacks.question
  })

  const feedbacksWithMember = (perspective: TextPerspectiveAnalysis) => {
    return perspective.texts.map((feedback) => ({
      ...feedback,
      member:
        analysisPerspectiveKey(perspective) === SELF_PERSPECTIVE_KEY ? user : feedback.sender,
    }))
  }

  const emits = defineEmits<{
    (e: 'toggleFeedback', feedbackId: string): void
  }>()

  const toggleFeedback = (feedbackId: string) => {
    emits('toggleFeedback', feedbackId)
  }

  const isFeedbackSelected = (feedbackId: string) => {
    return props.selectedFeedbackIds.has(feedbackId)
  }
</script>
